import React from 'react';
import { Heading, Text } from '@fiverr-private/typography';
import { Container } from '@fiverr-private/layout_components';
import { Variant } from '../../../types';

interface IdentificationFormHeaderProps {
    title: string;
    subTitle: React.ReactNode;
    variant?: Variant;
}

export const IdentificationFormHeader = ({ title, subTitle, variant }: IdentificationFormHeaderProps) => {
    const isOnboarding = variant === 'onboarding';

    return (
        <Container>
            {title && (
                <Heading as={isOnboarding ? 'h3' : 'h4'} marginBottom="2">
                    {title}
                </Heading>
            )}
            {subTitle && (
                <Text as="span" color="bodySecondary">
                    {subTitle}
                </Text>
            )}
        </Container>
    );
};
